"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProviderCardUtilities = void 0;
const isString_1 = __importDefault(require("lodash/isString"));
const util_1 = require("../../common/util");
const assets_1 = require("../../common/util/constants/assets");
const globals_1 = require("../../common/util/constants/globals");
const providerName = (provider) => (0, isString_1.default)(provider.name) ? provider.name : (0, util_1.getProviderDisplayName)(provider);
const useProviderCardUtilities = ({ track, viewAvailabilityLinkTarget, viewProviderLinkTarget, createAvailabilityUrl, createProviderUrl, renderType = assets_1.SIMILAR_PROVIDERS }) => {
    const { SIMILAR_PROVIDER_VIEW_PROVIDER_PROFILE, CARE_TEAM_VIEW_PROVIDER_PROFILE, SIMILAR_PROVIDER_VIEW_AVAILABILITY_CTA, CARE_TEAM_VIEW_AVAILABILITY_CTA, CARE_TEAM_VIEW_PROVIDER_PROFILE_CTA } = globals_1.LOGGING.MESSAGE;
    const viewAvailabilityCallback = ({ provider }) => () => {
        const getProviderName = providerName(provider);
        if (renderType === assets_1.SIMILAR_PROVIDERS) {
            track(SIMILAR_PROVIDER_VIEW_AVAILABILITY_CTA, {
                similar_provider_name: getProviderName
            });
        }
        if (renderType === assets_1.CARE_TEAM) {
            track(CARE_TEAM_VIEW_AVAILABILITY_CTA, {
                care_team_provider: getProviderName
            });
        }
        if (typeof window !== 'undefined') {
            window.open(createAvailabilityUrl(provider), viewAvailabilityLinkTarget);
        }
    };
    const viewProviderCallback = ({ provider }) => () => {
        const getProviderName = providerName(provider);
        if (renderType === assets_1.CARE_TEAM) {
            track(CARE_TEAM_VIEW_PROVIDER_PROFILE, {
                care_team_provider: getProviderName
            });
        }
        if (renderType === assets_1.SIMILAR_PROVIDERS) {
            track(SIMILAR_PROVIDER_VIEW_PROVIDER_PROFILE, {
                similar_provider_name: getProviderName
            });
        }
        if (typeof window !== 'undefined') {
            window.open(createProviderUrl(provider), viewProviderLinkTarget);
        }
    };
    const viewProviderCTACallback = ({ provider }) => () => {
        const getProviderName = providerName(provider);
        if (renderType === assets_1.CARE_TEAM) {
            track(CARE_TEAM_VIEW_PROVIDER_PROFILE_CTA, {
                care_team_provider: getProviderName
            });
        }
        if (renderType === assets_1.SIMILAR_PROVIDERS) {
            track(SIMILAR_PROVIDER_VIEW_PROVIDER_PROFILE, {
                similar_provider_name: getProviderName
            });
        }
        if (typeof window !== 'undefined') {
            window.open(createProviderUrl(provider), viewProviderLinkTarget);
        }
    };
    return {
        viewAvailabilityCallback,
        viewProviderCallback,
        viewProviderCTACallback
    };
};
exports.useProviderCardUtilities = useProviderCardUtilities;
//# sourceMappingURL=useProviderCardUtilities.js.map